import getApplicationVariant, {
  APPLICATION_VARIANTS
} from 'bento-ordering/utils/getApplicationVariant';

export const COMMERCE_TYPES = {
  ONLINE_ORDERING: 'online_ordering',
  DINE_IN_ORDERING: 'dine_in_ordering',
  NONE: ''
};

export default () => {
  switch (getApplicationVariant()) {
    case APPLICATION_VARIANTS.ONLINE_ORDERING:
      return COMMERCE_TYPES.ONLINE_ORDERING;
    case APPLICATION_VARIANTS.DINE_IN:
      return COMMERCE_TYPES.DINE_IN_ORDERING;
    default:
      return COMMERCE_TYPES.NONE;
  }
};
